<template>
    <div>
        <div class="container">
            <div class="row">
                <!-- <div class="col-lg-12">
                    <div class="team-member-wrapper">
                        <div class="row d-flex justify-content-center"> -->
                            <!--Team member start-->
                            <div v-for="teamMember in teamData.teamMemberData" :key="teamMember.id">
                                <div class="team">
                                    <div class="image">
                                        <img :src="teamMember.image" alt="team member image">
                                    </div>
                                    <div class="content">
                                        <h3 class="title">{{ teamMember.name }}</h3>
                                        <span>{{ teamMember.designation }}</span>
                                        <a href="mailto:info@example.com" class="email">{{ teamMember.email }}</a>
                                        <div class="social">
                                            <a :title="item.title" :href="item.link" :class="item.addClass" target="_blank" v-for="item in teamMember.social" :key="item.id">
                                                <i :class="item.icon"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Team member end-->
                        <!-- </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['teamData']
    };
</script>